import { HttpClient } from '@wix/http-client';
import { WidgetPlugin } from '../../types/widgetPlugins';

const httpClient = new HttpClient({
  baseURL: '/_serverless/editor-platform-widget-plugins/',
});

export interface GetWidgetPluginsProps {
  includeApps?: string[];
  interfaces?: string[];
  lang?: string;
}

export async function getWidgetPlugins(
  params: GetWidgetPluginsProps,
): Promise<WidgetPlugin[]> {
  const queryParams = new URLSearchParams();

  // This allows to send experiments override to serverless function
  const petriOvrString = new URL(window.location.href).searchParams.get(
    'petri_ovr',
  );
  if (petriOvrString) {
    queryParams.append('petri_ovr', petriOvrString);
  }
  if (params.includeApps?.length) {
    queryParams.append('include-apps', params.includeApps.join(','));
  }
  if (params.interfaces?.length) {
    queryParams.append('interfaces', params.interfaces.join(','));
  }
  if (params.lang) {
    queryParams.append('lang', params.lang);
  }
  const res = await httpClient.get<WidgetPlugin[]>(
    `/widget-plugins?${queryParams.toString()}`,
  );

  return res.data;
}
